/* tslint:disable */

/**
 * HR Portal API
 * HR Portal API
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
import {
    ContentItem,
    ContentItemFromJSON,
    ContentItemToJSON,
} from './';

/**
 *
 * @export
 * @interface Section
 */
export interface Section {
    /**
     *
     * @type {string}
     * @memberof Section
     */
    id?: string;
    /**
     *
     * @type {string}
     * @memberof Section
     */
    title: string;
    /**
     *
     * @type {string}
     * @memberof Section
     */
    slug?: string;
    /**
     *
     * @type {Array<ContentItem>}
     * @memberof Section
     */
    articles?: ContentItem[];
}

export function SectionFromJSON(json: any): Section {
    return SectionFromJSONTyped(json, false);
}

export function SectionFromJSONTyped(json: any, _: boolean): Section {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {

        'id': !exists(json, 'id') ? undefined : json['id'],
        'title': json['title'],
        'slug': !exists(json, 'slug') ? undefined : json['slug'],
        'articles': !exists(json, 'articles') ? undefined : ((json['articles'] as any[]).map(ContentItemFromJSON)),
    };
}

export function SectionToJSON(value?: Section | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {

        'id': value.id,
        'title': value.title,
        'slug': value.slug,
        'articles': value.articles === undefined ? undefined : ((value.articles as any[]).map(ContentItemToJSON)),
    };
}
